import { useCallback } from "react";

import { FilterIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export type ParticipantRoleFilter =
  | "all"
  | "salesperson"
  | "customer"
  | "observer"
  | "unknown";

export interface ParticipantRoleFilterDropdownProps {
  value: ParticipantRoleFilter;
  onSelect: (value: ParticipantRoleFilter) => void;
}

export const ParticipantRoleFilterDropdown = ({
  value,
  onSelect,
}: Readonly<ParticipantRoleFilterDropdownProps>) => {
  const handleChoice = useCallback(
    (value: ParticipantRoleFilter) => {
      onSelect(value);
    },
    [onSelect],
  );

  const getDisplayName = (filterValue: ParticipantRoleFilter): string => {
    switch (filterValue) {
      case "salesperson":
        return "Salesperson";
      case "customer":
        return "Customer";
      case "observer":
        return "Observer";
      case "unknown":
        return "Unknown";
      case "all":
        return "All";
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" variant="ghost">
          <span className="mr-2">{getDisplayName(value)}</span>{" "}
          <FilterIcon size={16} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem onClick={() => handleChoice("customer")}>
          Customer
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleChoice("salesperson")}>
          Salesperson
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleChoice("observer")}>
          Observer
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleChoice("unknown")}>
          Unknown
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleChoice("all")}>
          All
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
